import styled from 'styled-components';
import { thdLink } from '../../utils/colors';

// eslint-disable-next-line import/prefer-default-export
export const LinkText = styled.span`
  color: ${thdLink};
  cursor: pointer;
`;
